<mat-toolbar color="primary" class="flex justify-between items-center px-4">
  <div class="flex items-center gap-4">
    <a
      [routerLink]="'/'"
      class="flex items-center gap-2 text-primary hover:opacity-80 transition-opacity"
      aria-label="Go to homepage"
    >
      <img
        src="https://stslfiledistribution.blob.core.windows.net/public/STSL_logo.svg"
        alt="App Logo"
        class="h-8 w-auto"
      />
      <span class="font-semibold text-lg">{{ appHeaderAlias() }}</span>
    </a>

    <div class="hidden md:flex items-center text-sm">
      <button mat-button [routerLink]="userData ? getAdminRoute() : '/'">
        <mat-icon class="mr-1">{{ userData ? "lock" : "home" }}</mat-icon>
        <span>{{ userData ? "Manage" : "Home" }}</span>
      </button>
    </div>
    @if (currentTenantHelpPortalUrl()) {
      <div class="hidden md:flex items-center text-sm">
        <a mat-button [href]="currentTenantHelpPortalUrl()">
          <mat-icon>help</mat-icon>
          <span>Help</span>
        </a>
      </div>
    }
  </div>

  <div class="flex items-center justify-center gap-2">
    <div class="hidden md:inline-flex">
      <app-tenant-switcher></app-tenant-switcher>

      @if (
        hasRole(UserRole.SuperUser) &&
        (userData?.roles?.length || userData?.tenants?.length)
      ) {
        <button
          mat-button
          class="hidden md:flex items-center gap-2 text-xs"
          [matMenuTriggerFor]="devToolsMenu"
        >
          <span class="flex items-center gap-2 text-xs">
            <span class="font-medium">Dev Tools</span>
            <mat-icon style="scale: 0.5">expand_more</mat-icon>
          </span>
        </button>
      }

      @if (userData) {
        <button
          mat-button
          [matMenuTriggerFor]="userMenu"
          class="hidden md:inline-flex items-center gap-2 text-sm"
        >
          <span class="flex items-center text-sm gap-2">
            <img
              *ngIf="userData.picture"
              [src]="userData.picture"
              class="w-6 h-6 rounded-full"
            />
            <span class="truncate max-w-[10rem]">{{ userData.name }}</span>
            <mat-icon>expand_more</mat-icon>
          </span>
        </button>
      } @else {
        <button
          mat-button
          class="hidden md:flex items-center gap-2 text-sm"
          (click)="loginUser()"
        >
          <mat-icon>account_circle</mat-icon>
          <span>Login</span>
        </button>
      }
    </div>

    <!-- Burger Menu (Mobile Only) -->
    <div class="md:hidden">
      <button
        mat-icon-button
        class="md:hidden"
        [matMenuTriggerFor]="mainMenu"
        (menuOpened)="menuOpened()"
        (menuClosed)="menuClosed()"
        aria-label="Toggle mobile menu"
      >
        <mat-icon>{{ menuIsOpen ? "close" : "menu" }}</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>

<!-- Mobile Menu -->
<mat-menu #mainMenu="matMenu">
  @if (userData) {
    <button mat-menu-item disabled class="text-left text-xs leading-tight">
      <div>{{ userData.name }}</div>
      <div class="opacity-70">{{ userData.email }}</div>
    </button>
    <mat-divider />
  }

  <button mat-menu-item [routerLink]="userData ? getAdminRoute() : '/'">
    <mat-icon class="mr-2">{{ userData ? "lock" : "home" }}</mat-icon>
    <span>{{ userData ? "Manage" : "Home" }}</span>
  </button>

  @if (currentTenantHelpPortalUrl()) {
    <a mat-menu-item [href]="currentTenantHelpPortalUrl()">
      <mat-icon>help</mat-icon>
      <span>Help</span>
    </a>
  }

  @if (
    inDevelopment && hasRole(UserRole.SuperUser) && (userData?.roles?.length || userData?.tenants?.length)
  ) {
    <button mat-menu-item [matMenuTriggerFor]="devToolsMenu">
      <mat-icon class="mr-2">build</mat-icon>
      <span>Dev Tools</span>
    </button>
  }

  <mat-divider />

  @if (userData) {
    <button mat-menu-item (click)="logoutUser()">
      <mat-icon class="mr-2">meeting_room</mat-icon>
      <span>Logout</span>
    </button>
  } @else {
    <button mat-menu-item (click)="loginUser()">
      <mat-icon class="mr-2">account_circle</mat-icon>
      <span>Login</span>
    </button>
  }
</mat-menu>

<mat-menu #userMenu="matMenu">
  <button mat-menu-item (click)="logoutUser()">
    <mat-icon class="mr-2">meeting_room</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>

<mat-menu #devToolsMenu="matMenu">
  @if (userData?.roles?.length && inDevelopment) {
    <button mat-menu-item [matMenuTriggerFor]="rolesMenu">
      <mat-icon class="mr-2">supervised_user_circle</mat-icon>
      <span>Roles</span>
    </button>
  }

  <button mat-menu-item [matMenuTriggerFor]="featureFlagsMenu">
    <mat-icon>flag</mat-icon>
    <span>Toggle Feature Flags</span>
  </button>
</mat-menu>

<mat-menu #rolesMenu="matMenu">
  @for (role of userData?.roles ?? []; track role) {
    <button mat-menu-item (click)="toggleRole(role)">
      @if (isRoleEnabled(role)) {
        <mat-icon class="mr-2">done</mat-icon>
      }
      <span>Role: {{ role }}</span>
    </button>
  }
</mat-menu>

<mat-menu #featureFlagsMenu="matMenu">
  <button
    mat-menu-item
    *ngFor="let flag of featureFlags"
    (click)="toggleFeatureFlag(flag.value)"
  >
    <mat-icon>{{
      isFeatureFlagSet(flag.value) ? "flag" : "outlined_flag"
    }}</mat-icon>
    <span>{{ flag.name }}</span>
  </button>
</mat-menu>
<mat-menu #featureFlagsMenu="matMenu">
  <button
    mat-menu-item
    *ngFor="let flag of featureFlags"
    (click)="toggleFeatureFlag(flag.value)"
  >
    <mat-icon>{{
      isFeatureFlagSet(flag.value) ? "flag" : "outlined_flag"
    }}</mat-icon>
    <span>{{ flag.name }}</span>
  </button>
</mat-menu>
